import { createFileRoute } from "@tanstack/react-router";
import { fetchAuthSession } from "aws-amplify/auth";
import { LoginPage } from "../pages/Login/LoginPage";
import { useShellHost } from "../shell-handle/ShellHostProvider";
import { createAuthApi } from "../shell-handle/auth";
import {
  TIDE_TOKEN_KEY,
  AKVA_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
} from "../shell-handle/syncedTokens";

async function syncTokensToLocalStorage() {
  try {
    const s = await fetchAuthSession();
    const id = s.tokens?.idToken?.toString();
    const access = s.tokens?.accessToken?.toString();
    if (id) {
      localStorage.setItem(TIDE_TOKEN_KEY, id);
      localStorage.setItem(AKVA_TOKEN_KEY, id);
    }
    const refresh = access || id;
    if (refresh) localStorage.setItem(REFRESH_TOKEN_KEY, refresh);
  } catch {
    /* not signed in */
  }
}

function LoginRoute() {
  const host = useShellHost();
  const auth = createAuthApi();
  return (
    <LoginPage
      signIn={(email, password) => auth.signIn(email, password)}
      confirmSignIn={(newPassword) => auth.confirmSignIn(newPassword)}
      onSuccess={async () => {
        await syncTokensToLocalStorage();
        await host.loadInitialData();
        // Use full navigation so the tide MFE (mounted on non-shell-owned
        // paths via single-spa) takes over and renders the welcome page.
        // tanstack-router's typed nav has no `/welcome` route; the splat
        // route '/$' catches it at runtime.
        window.location.assign("/welcome");
      }}
    />
  );
}

export const Route = createFileRoute("/login")({
  component: LoginRoute,
});
